const IMPORTANT_LABELS = {
  allergies: "Allergy", blood: "Blood Type", dietary: "Dietary Restriction", medical: "Medical Info",
  religion: "Religion / Faith", emergency: "Emergency Info",
};

export const importantLabel = (it) =>
  IMPORTANT_LABELS[it.subcategory] || it.data?.custom_type?.trim() || "Custom";
